var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgTableNoData = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 54,
    viewBox: "0 0 60 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_966_17875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 38.3335C30 30.0522 36.7188 23.3335 45 23.3335C53.2812 23.3335 60 30.0522 60 38.3335C60 46.6147 53.2812 53.3335 45 53.3335C36.7188 53.3335 30 46.6147 30 38.3335ZM46.5729 31.6668C46.5729 30.7502 45.9167 30.0002 44.9062 30.0002C44.0833 30.0002 43.2396 30.7502 43.2396 31.6668V38.3335C43.2396 39.2502 44.0833 40.0002 44.9062 40.0002H50C50.9167 40.0002 51.6667 39.2502 51.6667 38.3335C51.6667 37.4168 50.9167 36.6668 50 36.6668H46.5729V31.6668Z",
    fill: "#D0D3DA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0 3.33333C0 1.49271 1.49271 0 3.33333 0H36.6667C38.5104 0 40 1.49271 40 3.33333C40 5.17396 38.5104 6.66667 36.6667 6.66667V7.81042C36.6667 12.2292 34.9062 16.4688 31.7812 19.5938L24.7188 26.6667L28.4583 30.3229C27.3125 32.7188 26.6667 35.5 26.6667 38.3333C26.6667 44.5313 29.75 50.0104 34.4583 53.3333H3.33333C1.49271 53.3333 0 51.8438 0 50C0 48.1563 1.49271 46.6667 3.33333 46.6667V45.5208C3.33333 41.1042 5.08958 36.8646 8.21458 33.7396L15.2812 26.6667L8.21458 19.5938C5.08958 16.4688 3.33333 12.2292 3.33333 7.81042V6.66667C1.49271 6.66667 0 5.17396 0 3.33333ZM10 6.66667V7.81042C10 9.78958 10.5833 11.7083 11.5729 13.3333H28.3333C29.4167 11.7083 30 9.78958 30 7.81042V6.66667H10Z",
    fill: "#D0D3DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_966_17875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 53.3333,
    fill: "white"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgTableNoData);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/table-no-data.bd0d9d37efd53db9bd83be1f5e023352.svg";